// @ts-check

export default {
    C2H4O2:    'acetic acid',
    C3H6O:     'acetone',
    C2H3N:     'acetonitrile',
    C6H6:      'benzene',
    CCl4:      'carbon tetrachloride',
    C6H5Cl:    'chlorobenzene',
    CHCl3:     'chloroform',
    C6H12:     'cyclohexane',
    C2H4Cl2:   '1,2-dichloroethane',
    C4H10O3:   'diethylene glycol',
    C6H14O3:   'diglyme',
    C4H10O2:   'DME',
    C3H7NO:    'DMF',
    C2H6OS:    'DMSO',
    C2H6O:     'ethanol',
    C2H6O2:    'ethylene glycol',
    C3H8O3:    'glycerin',
    C7H16:     'heptane',
    C6H18N3OP: 'HMPA',
    C6H18N3P:  'HMPT',
    C6H14:     'hexane',
    CH4O:      'methanol',
    C5H12O:    'MTBE',
    CH2Cl2:    'methylene chloride',
    CH5H9NO:   'NMP',
    CH3NO2:    'nitromethane',
    C5H12:     'pentane',
    C5H5N:     'pyridine',
    C7H8:      'toluene',
    C6H15N:    'triethyl amine',
    H2O:       'water',
};
